import * as yup from 'yup';

export const otherReasonForIncomeDifferentialsValidationSchema = (maxDetailLength: number) =>
  yup.object({
    hasPolicyForverticalGap: yup
      .number()
      .typeError('Please indicate if your organisation has a policy to address pay gaps.')
      .required('Please indicate if your organisation has a policy to address pay gaps.'),
    isRemunerationGapAlignedToPolicy: yup
      .number()
      .typeError('Response required on remuneration gap alignment with policy.')
      .required('Response required on remuneration gap alignment with policy.'),
    hasAAMeasures: yup
      .number()
      .typeError('Please indicate if AA measures to address the remuneration gap are included in your EE Plan.')
      .required('Please indicate if AA measures to address the remuneration gap are included in your EE Plan.'),
    reasonForIncomeDifferentials: yup
      .number()
      .typeError('Reason is required')
      .required('Reason is required'), 
    otherReasonForIncomeDifferentials: yup
      .string()
      .nullable()
      .max(
        maxDetailLength,
        `Detail is too long! (Max length is ${maxDetailLength} characters)`
      )
      .when('reasonForIncomeDifferentials', {
        is: 8,
        then: schema => schema.required('Please provide a reason when "Other" is selected.'),
        otherwise: schema => schema.nullable().notRequired(),
      }),
  });